const angular = require('angular');

export default angular.module('nomasvelloDashboardApp.monthlySelling.newClientsReportRow', [])
  .directive('newClientsReportRow', function () {
    return {
      template: require('./newClientsReportRow.pug'),
      replace: true,
      restrict: 'C'
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/manager/monthlySelling/directives/newClientsReportRow/index.ts